import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Zillow(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#0066CC" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M8.85655 8.67766C10.1369 7.70507 11.9568 6.32268 12.6492 6C13.0894 6.21559 14.7194 7.3278 15.2994 7.73847C13.4422 7.7823 9.81703 8.5888 8.30814 9.09348C8.47399 8.96825 8.65883 8.82784 8.85655 8.67766ZM10.4409 13.1695C11.1462 12.5181 15.6457 7.98128 15.6457 7.98128C17.3906 9.17725 19.1998 10.6457 19.1998 10.6457L16.8187 10.8843C16.8187 10.8843 16.5997 11.343 16.393 11.9756C14.6126 12.0824 11.81 12.6733 10.4409 13.1695ZM12.6992 9.16489C12.6992 9.16489 7.60066 13.888 6.18368 15.3522L7.35452 12.1661L7.16142 12.1946L7.16142 12.1946C6.38108 12.3093 5.95236 12.3723 4.7998 12.6189L6.28791 11.0833C7.27705 10.6309 10.0466 9.78691 12.6992 9.16489ZM5.41153 17.5201C5.92282 17.2939 10.771 15.6749 15.2286 15.4066C15.2785 15.2104 15.4347 14.7737 15.5856 14.3515C15.7248 13.9624 15.8595 13.5857 15.9026 13.4208C11.278 13.7519 7.51728 15.1387 6.00628 15.8403L5.41153 17.5201Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

Zillow.propTypes = propTypes;
Zillow.defaultProps = defaultProps;

export default Zillow;
